import PropTypes from 'prop-types'

import { InlineLink } from '@scouts/ui'

const LinkRenderer = ({ href, children }) => (
    <InlineLink href={href} target="_blank" rel="noopener noreferrer">
        {children}
    </InlineLink>
)

LinkRenderer.propTypes = {
    href: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
}

export default LinkRenderer
